import { getApiUrl } from "#/constants/environment";
import { fetchJson } from "#/utils/fetch";
import { Logger } from "#/lib/logging";
import { GetProductsResponse, GetProductsResponseSchema } from "#next/pages/api/stripe/products.api";
import { isBrowser } from "#/utils/environment";
import { getProduct } from "#/lib/stripe";

export const getStripeProducts = async (): Promise<GetProductsResponse["products"]> => {
  if (!isBrowser()) {
    const products = await Promise.all([
      getProduct({ productId: process.env.NEXT_PUBLIC_STRIPE_PRO_ID }),
      getProduct({ productId: process.env.NEXT_PUBLIC_STRIPE_ENTERPRISE_ID })
    ]);
    return products;
  }
  const {
    data, failure
  } = await fetchJson(`${getApiUrl()}/api/stripe/products`, null, GetProductsResponseSchema);
  if (failure) {
    throw Logger.error({
      message: "Failed to get stripe products",
      error: failure.error,
      metadata: failure.metadata
    });
  }
  return data?.products;
};